import { useIntl } from 'react-intl'

import {
  OfferConditionTypeEnumV2,
  OfferDiscountTypeEnumV2,
  type SellerPromotionV2,
} from '@redteclab/api/clients/promotion-service'

import {
  getFormattedPromotionDiscountedAmountOrPercentage,
  getFormattedPromotionDiscountValueWithCurrency,
} from '../../models'

export const useProductSellerPromotionDetails = (
  sellerPromotion: SellerPromotionV2,
): {
  discount: string
  endDate: string | null
  isFreeItems: boolean
  isQuantityPromotion: boolean
  isSameItemPromotion: boolean
  minimumOrderValue: string
  payableQuantity: number
  quantity: string
} => {
  const intl = useIntl()

  return {
    discount: getFormattedPromotionDiscountedAmountOrPercentage(
      sellerPromotion,
      intl,
    ),
    endDate: sellerPromotion.endDate
      ? intl.formatDate(new Date(sellerPromotion.endDate))
      : null,
    isFreeItems:
      sellerPromotion.discountType === OfferDiscountTypeEnumV2.FreeItems,
    isQuantityPromotion:
      sellerPromotion.conditionType ===
        OfferConditionTypeEnumV2.MinimumQuantity ||
      sellerPromotion.conditionType ===
        OfferConditionTypeEnumV2.MinimumSameItemQuantity,
    isSameItemPromotion:
      sellerPromotion.conditionType ===
      OfferConditionTypeEnumV2.MinimumSameItemQuantity,
    minimumOrderValue: getFormattedPromotionDiscountValueWithCurrency(
      sellerPromotion.conditionValue,
      intl,
    ),
    payableQuantity:
      sellerPromotion.conditionValue - sellerPromotion.discountValue,
    quantity: intl.formatNumber(sellerPromotion.conditionValue),
  }
}
